import { Transcript } from "./CompanyPodcast/Transcript";

export type CompanyPodcastData = {
  user: {
    name: string;
    role: string;
    image: {
      src: string;
    };
  };
  quote: string;
  audio: {
    src: string;
  };
  transcript: string;
  jobId: string;
};

export function CompanyPodcast({
  companyPodcastData,
}: {
  companyPodcastData: CompanyPodcastData;
}) {
  return <Transcript transcript={companyPodcastData.transcript} />;
}
